import React from "react";
import { useClassNames } from "../../../../utils/useClassNames";
import styles from "./styles.module.scss";

export type ToggleContentItemProps = {
  className?: string;
  style?: React.CSSProperties;
  title: string;
  titleColor?: React.CSSProperties["color"];
  titleSize?: React.CSSProperties["fontSize"];
  withBorder?: boolean;
};

const ToggleContentItem: React.FC<
  React.PropsWithChildren<ToggleContentItemProps>
> = ({
  children,
  style,
  title,
  withBorder,
  titleColor = "#d81b60",
  titleSize = 24,
  ...props
}) => {
  const containerClassName = useClassNames(
    styles["Container"],
    props.className,
    {
      [styles["WithBorder"]]: withBorder,
    }
  );

  return (
    <div className={containerClassName}>
      <div className={styles["Inner"]} style={style}>
        <div
          className={styles["Title"]}
          style={{
            color: titleColor,
            fontSize: titleSize,
          }}
        >
          {title}
        </div>
        {children}
      </div>
    </div>
  );
};

export default ToggleContentItem;
